module.exports = __webpack_public_path__ + "img/logo.4404587e.png";